const React = require('react');
const PropTypes = require('prop-types');

require('./passContainer.scss');

class PassContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { children, step, title, buttons, disable } = this.props;
        const overlay = disable ? (<div className="container-keyscc__overlay"></div>) : null;

        return (
            <div className="container-keyscc">
                <div className="container-keyscc__header">
                    <span className="container-keyscc__step">
                        {step}
                    </span>
                    <h2 className="container-keyscc__title">
                        {title}
                    </h2>
                </div>
                <div className="container-keyscc__body">
                    {children}
                </div>
                <div className="container-keyscc__footer">
                    {buttons}
                </div>
                {overlay}
            </div>
        );
    }
}

PassContainer.propTypes = {
    children: PropTypes.node.isRequired,
    buttons: PropTypes.object.isRequired,
    step: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    disable: PropTypes.bool.isRequired
};

module.exports = PassContainer;
